import { h } from 'preact'
import { Link } from 'preact-router/match'
import { useState } from 'preact/hooks'

export const AppBar = () => {
  const [open, setOpen] = useState<boolean>(false)

  const handleClickLink = (event: Event) => {
    event.preventDefault()
    setOpen(false)
  }

  const handleClickMenu = (event: Event) => {
    event.preventDefault()
    if (open) {
      setOpen(false)
    } else {
      setOpen(true)
    }
  }

  return (
    <header className="app-bar">
      <div className="brand">
        <img src="/assets/logo.png" className="brand-logo" />
        <div>IEEE広島支部学生ブランチ Hiroshima Section Student Branch</div>
      </div>
      <nav className="nav-link">
        <Link class="link" activeClassName="link--active" href="/">
          Home
        </Link>
        <Link class="link" activeClassName="link--active" href="/about">
          About
        </Link>
        <Link class="link" activeClassName="link--active" href="/member">
          Member
        </Link>
        <Link class="link" activeClassName="link--active" href="/contact">
          Contact
        </Link>
        <Link class="link" activeClassName="link--active" href="/rule">
          Rule
        </Link>
      </nav>
      <div className="nav-menu" onClick={handleClickMenu}>
        {open ? <img src="/assets/menu-close.svg" width={24} /> : <img src="/assets/menu-open.svg" width={24} />}
      </div>
      {open && (
        <div className="menu">
          <div className="menu-item">
            <Link onClick={handleClickLink} class="link" activeClassName="link--active" href="/">
              Home
            </Link>
          </div>
          <div className="menu-item">
            <Link onClick={handleClickLink} class="link" activeClassName="link--active" href="/about">
              About
            </Link>
          </div>
          <div className="menu-item">
            <Link onClick={handleClickLink} class="link" activeClassName="link--active" href="/member">
              Member
            </Link>
          </div>
          <div className="menu-item">
            <Link onClick={handleClickLink} class="link" activeClassName="link--active" href="/contact">
              Contact
            </Link>
          </div>
        </div>
      )}
    </header>
  )
}
